module.exports = __webpack_public_path__ + "img/plus_active_hover.bece2019.svg";